import styled, { css } from "styled-components";

import { breakpoint } from "src/library/utils/styled-media-queries";

export const CreditQuantityField = styled.input.attrs({ type: "number" })<{ value: string }>`
${({ theme, value: quantity }) => css`
  appearance: none;
  height: 100%;
  padding: 0;
  vertical-align: top;
  width: calc(20px + ${quantity.length * 7}px); // dynamic get bigger
  border-radius: 0;
  text-align: center;
  border-top: 1px solid ${theme.colors.lightGrey};
  border-right: none;
  border-bottom: 1px solid ${theme.colors.lightGrey};
  border-left: none;
  outline: none;
  font-size: 12px; // hard coded as needs to not change
  padding-left: 12px;

  &:focus,
  &:hover {
    color: ${theme.colors.primaryDark};
  }

  ${breakpoint("sm", theme)} {
    font-size: ${theme.fonts.sizes.p};
    width: calc(38px + ${quantity.length * 7}px); // dynamic get bigger
  }

  @media (hover: none) and (pointer: coarse) {
    padding-left: 0px;
  }
`}
`;
